import { render } from "./ContentModal.vue?vue&type=template&id=270bbc57&scoped=true"
import script from "./ContentModal.vue?vue&type=script&lang=js"
export * from "./ContentModal.vue?vue&type=script&lang=js"

import "./ContentModal.vue?vue&type=style&index=0&id=270bbc57&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270bbc57"]])

export default __exports__